import {deletePromotionImage} from '../../../service/promotions/promotions-api';
import {useUploadPromotionImage} from '../../../service/promotions/promotions-hook';
import {PromotionFormFieldsEnum, PromotionFormType} from '../../../service/promotions/promotions-type';
import {Form} from '../../../typings/antd';
import {noop} from '../../../util/function';
import {
    PUBLICATION_MEDIA_MAX_HEIGHT,
    PUBLICATION_MEDIA_MAX_WIDTH,
    PUBLICATION_MEDIA_MIN_HEIGHT,
    PUBLICATION_MEDIA_MIN_WIDTH,
    PublicationMediaStep,
} from '../../publication-wizard/publication-media-step';
import {Text} from '../../text/text';

type PropsType = {
    onPreviousStep: VoidFunction;
    onStepFinished: VoidFunction;
    onStepActivated: (width: number) => void;
    width: number;
};

const banner = (
    <>
        <Text block bolder stringKey="PROMOTIONS__FORM__IMAGES" />
        <Text block stringKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__RULES_2" />
        <Text
            block
            stringKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__RULES_3"
            valueMap={{
                maxHeight: PUBLICATION_MEDIA_MAX_HEIGHT,
                maxWidth: PUBLICATION_MEDIA_MAX_WIDTH,
                minHeight: PUBLICATION_MEDIA_MIN_HEIGHT,
                minWidth: PUBLICATION_MEDIA_MIN_WIDTH,
            }}
        />
    </>
);

// Single image for promotions.
export function PromotionMediaStep(props: PropsType): JSX.Element {
    const {onPreviousStep, onStepFinished, onStepActivated, width} = props;

    const {mutateAsync: uploadImage} = useUploadPromotionImage();

    return (
        <Form.Item<PromotionFormType> name={PromotionFormFieldsEnum.Images} noStyle>
            <PublicationMediaStep
                banner={banner}
                maxCount={1}
                onPreviousStep={onPreviousStep}
                onStepActivated={onStepActivated}
                onStepFinished={onStepFinished}
                remove={(imageId) => deletePromotionImage(imageId).catch(noop)}
                upload={(file) => uploadImage(file)}
                uploaderTextLangKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__UPLOADER_TEXT"
                width={width}
            />
        </Form.Item>
    );
}
